/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  ExpandableSection
} from '../'

export class ExpandableOverviewItem extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    summary: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    children: PropTypes.any,
    iconSymbol: PropTypes.string,
    iconColour: PropTypes.string,
    open: PropTypes.bool,
    onClick: PropTypes.func,
    locked: PropTypes.bool,
    className: PropTypes.string,
    singleItemCondensedView: PropTypes.bool
  }

  static defaultProps = {
    open: false,
    locked: false,
    singleItemCondensedView: false
  }

  render() {
    return (
      <div className={`slds-grid ${this.props.className ? this.props.className : ''}`}>
        {this.props.singleItemCondensedView === false &&
          <div className='slds-size_1-of-12 slds-align_absolute-center'>
            {this.props.iconSymbol && !this.props.open &&
              <SvgIcon
                variant='utility'
                symbol={this.props.iconSymbol}
                colour={this.props.iconColour}
                size='small'
              />
            }
          </div>
        }
        <div className={`slds-size_${this.props.singleItemCondensedView ? '1-of-1 slds-m-left_small' : '11-of-12'} slds-border_bottom`}>
          <ExpandableSection
            open={this.props.open}
            title={this.props.title}
            summary={this.props.summary}
            locked={this.props.locked}
            onClick={this.props.onClick}>
            {this.props.children}
          </ExpandableSection>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/expandable-overview-item/index.js